export function sortAlphabetically<T extends Record<string, any>>(arr: Array<T>, key: keyof T): Array<T> {
    return arr
        .slice() // Create a copy of the array to avoid mutating the original array
        .sort((a, b) => {
            if (!a[key] || !b[key]) return 0;
            let textA = a[key].toUpperCase();
            let textB = b[key].toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
};